import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DexieService } from './dexieService';
import { OnlineService } from './online.service';
import { Observable, from, map } from 'rxjs';
import { HttpUtils } from '../utils/httpUtils';
import { ExecutionAttachmentFilter, ExecutionQTest } from '../model/execution';
import { DateUtils } from '../utils/dateUtils';


@Injectable({
    providedIn: 'root'
})
export class ExecutionQTestsService {

    protected readonly baseUrl = `${environment.qualificatesUrl}/executionQTest`;

    constructor(private http: HttpClient,
        private dexieService: DexieService,
        private onlineService: OnlineService) { }

    findByTestTypeId(id: number): Observable<any> {
        if (this.onlineService.latestOnline) {
            return this.http.get(`${this.baseUrl}/testType/${id}`).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
        } else {
            return from(this.dexieService.roomType.toArray().timeout(30000));
        }
    }

    findAll(id: number): Observable<any> {
        if (this.onlineService.latestOnline) {
            return this.http.get(`${this.baseUrl}/testType/${id}`).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
        } else {
            return from(this.dexieService.roomType.toArray().timeout(30000));
        }
    }

    getExecutionTestbyId(id: number): Observable<any> {
        const url = `${this.baseUrl}/${id}`;

        return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    getAttachments(id: number, filter: ExecutionAttachmentFilter): Observable<any> {
        const url = `${this.baseUrl}/${id}/attachment`;
        return this.http.post(url, filter).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }


    correctSensors(id: number, idEssayVariable: number, checks: number[]): Observable<any> {
        const url = `${this.baseUrl}/${id}/essay/${idEssayVariable}/correctSensors`;

        return this.http.put(url, checks).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    discardTime(id: number, idEssay: number, startDate: Date, endDate: Date): Observable<any> {
        const url = `${this.baseUrl}/${id}/essay/${idEssay}/discardTime`;

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            body: { startDate, endDate }
        };

        return this.http.delete(url, options).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    validateTest(id: number, token: string): Observable<any>  {
        const url = `${this.baseUrl}/validated/${id}`;
        const form = new FormData();
        form.append('token', token);
        return this.http.put(url, form).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }


    copyToEssay(idTest: number, idEssay: number, idEssayToCopy: number, dateFrom: Date, dateTo: Date): Observable<any> {
        const url = `${this.baseUrl}/${idTest}/copySensors/${idEssay}/${idEssayToCopy}`;

        const data = { dateFrom, dateTo };

        return this.http.post(url, data).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    updateTest(idExecution: number, dto: ExecutionQTest): Observable<any>  {
        const url = `${this.baseUrl}/${idExecution}`;
         for (let indexGroup = 0; indexGroup < dto.executionQTestEssayGroup?.length; indexGroup++) {
              const elementGroup =  dto.executionQTestEssayGroup[indexGroup];
        
            for (let indexValues = 0; indexValues < elementGroup.essayValues?.length; indexValues++) {
                const elementValue = elementGroup.essayValues[indexValues];
                if (elementValue.fcStartEssay != null) {
                    elementValue.fcStartEssay = DateUtils.anyToDate(elementValue.fcStartEssay as Date);
                    elementValue.fcStartEssay = new Date(`${elementValue.fcStartEssay.toString().split('GMT')[0]} UTC`).toISOString()
                        .split('.')[0] + '.000+0000';
                }

                if (elementValue.fcEndEssay != null) {
                    elementValue.fcEndEssay = DateUtils.anyToDate(elementValue.fcEndEssay as Date);
                    elementValue.fcEndEssay = new Date(`${elementValue.fcEndEssay.toString().split('GMT')[0]} UTC`).toISOString()
                        .split('.')[0] + '.000+0000';
                }

                elementValue.sensors?.forEach(s => {
                    delete s.data;
                });
            }
            
        }
        return this.http.put(url, dto).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }
}
